/* 
	该文件专门为组件生成action对象
*/

import { CHANGEROLE_LEFTNAV } from "../../config/constant"

export const changeRoleLeftNav = (data) => { return { type: CHANGEROLE_LEFTNAV, data } }